export default __webpack_public_path__ + "static/media/ic-docx.1720a88a.svg";